function getBaseLang() {
  const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!lang) return '';
  const parts = lang.split('-');
  return (parts[0] || '').toLowerCase();
}

function clearFieldValue(container) {
  const fields = container.querySelectorAll('.gesvalt-field');
  fields.forEach(field => {
    if (field.type === 'radio') {
      const form = field.closest('form');
      const radios = form ? form.querySelectorAll(`[name="${field.name}"]`) : [];
      radios.forEach(r => { r.checked = false; });
    } else if (field.type === 'checkbox') {
      field.checked = false;
    } else {
      field.value = '';
    }
    field.classList.remove('gesfor-field-error');
    const err = container.querySelector('.gesfor-error-message');
    if (err) err.remove();
  });
}

function toggleContainer(container, show) {
  if (show) {
    container.style.display = '';
    container.classList.remove('gesvalt-field-hidden');
  } else {
    container.style.display = 'none';
    container.classList.add('gesvalt-field-hidden');
    clearFieldValue(container);
  }
}

function applyVisibleLang() {
  const base = getBaseLang();
  const wrappers = document.querySelectorAll('[data-visible-lang]');
  wrappers.forEach(wrapper => {
    const requiredLang = (wrapper.getAttribute('data-visible-lang') || '').toLowerCase();
    const show = requiredLang && base ? base === requiredLang : true;
    toggleContainer(wrapper, show);
  });
}

document.addEventListener('DOMContentLoaded', applyVisibleLang);

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        if (node.matches && node.matches('.gesvalt-field-wrapper[data-visible-lang]')) {
          applyVisibleLang();
        } else if (node.querySelectorAll) {
          const any = node.querySelectorAll('.gesvalt-field-wrapper[data-visible-lang]');
          if (any.length) applyVisibleLang();
        }
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

